module.exports = __webpack_public_path__ + "images/halloween_lp/sec01_title_pc_98db65f49f3e64a57cd4ca6aacdfbb74.png";